import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_55867a84 from 'nuxt_plugin_plugin_55867a84' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_70cffde4 from 'nuxt_plugin_nuxtsvgsprite_70cffde4' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtgooglemaps_2dd52ad1 from 'nuxt_plugin_nuxtgooglemaps_2dd52ad1' // Source: ./nuxt-google-maps.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_libplugin5b535fd0_7540a5fc from 'nuxt_plugin_libplugin5b535fd0_7540a5fc' // Source: ./lib.plugin.5b535fd0.js (mode: 'all')
import nuxt_plugin_shimsaxios339e8f2c_68576c1b from 'nuxt_plugin_shimsaxios339e8f2c_68576c1b' // Source: ./shims.axios.339e8f2c.js (mode: 'all')
import nuxt_plugin_googleanalytics_0f318e20 from 'nuxt_plugin_googleanalytics_0f318e20' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_moment_42881812 from 'nuxt_plugin_moment_42881812' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_veevalidate_565c8945 from 'nuxt_plugin_veevalidate_565c8945' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_vuenotification_25d70570 from 'nuxt_plugin_vuenotification_25d70570' // Source: ../plugins/vue-notification (mode: 'all')
import nuxt_plugin_error_0e006850 from 'nuxt_plugin_error_0e006850' // Source: ../plugins/handlers/error (mode: 'all')
import nuxt_plugin_vuexpersistedstate_1da59343 from 'nuxt_plugin_vuexpersistedstate_1da59343' // Source: ../plugins/vuex-persistedstate (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_lodash_52e6a2ea from 'nuxt_plugin_lodash_52e6a2ea' // Source: ../plugins/lodash (mode: 'all')
import nuxt_plugin_dialogs_4974dff5 from 'nuxt_plugin_dialogs_4974dff5' // Source: ../plugins/dialogs (mode: 'all')
import nuxt_plugin_entry_7da264b0 from 'nuxt_plugin_entry_7da264b0' // Source: ../plugins/vuex-orm/entry (mode: 'all')
import nuxt_plugin_vuethemask_ab289cb6 from 'nuxt_plugin_vuethemask_ab289cb6' // Source: ../plugins/vue-the-mask (mode: 'all')
import nuxt_plugin_mixins_5013a1f0 from 'nuxt_plugin_mixins_5013a1f0' // Source: ../plugins/mixins (mode: 'all')
import nuxt_plugin_entry_6e62af46 from 'nuxt_plugin_entry_6e62af46' // Source: ../plugins/vee-validate/entry (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","title":"Navkolo","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Navkolo"},{"name":"robots","content":"noindex, follow"},{"hid":"nuxt-public-env","name":"nuxt-public-env","content":"{}"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffav.png"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_plugin_55867a84 === 'function') {
    await nuxt_plugin_plugin_55867a84(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_70cffde4 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_70cffde4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtgooglemaps_2dd52ad1 === 'function') {
    await nuxt_plugin_nuxtgooglemaps_2dd52ad1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin5b535fd0_7540a5fc === 'function') {
    await nuxt_plugin_libplugin5b535fd0_7540a5fc(app.context, inject)
  }

  if (typeof nuxt_plugin_shimsaxios339e8f2c_68576c1b === 'function') {
    await nuxt_plugin_shimsaxios339e8f2c_68576c1b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_0f318e20 === 'function') {
    await nuxt_plugin_googleanalytics_0f318e20(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_42881812 === 'function') {
    await nuxt_plugin_moment_42881812(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_565c8945 === 'function') {
    await nuxt_plugin_veevalidate_565c8945(app.context, inject)
  }

  if (typeof nuxt_plugin_vuenotification_25d70570 === 'function') {
    await nuxt_plugin_vuenotification_25d70570(app.context, inject)
  }

  if (typeof nuxt_plugin_error_0e006850 === 'function') {
    await nuxt_plugin_error_0e006850(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexpersistedstate_1da59343 === 'function') {
    await nuxt_plugin_vuexpersistedstate_1da59343(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_52e6a2ea === 'function') {
    await nuxt_plugin_lodash_52e6a2ea(app.context, inject)
  }

  if (typeof nuxt_plugin_dialogs_4974dff5 === 'function') {
    await nuxt_plugin_dialogs_4974dff5(app.context, inject)
  }

  if (typeof nuxt_plugin_entry_7da264b0 === 'function') {
    await nuxt_plugin_entry_7da264b0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuethemask_ab289cb6 === 'function') {
    await nuxt_plugin_vuethemask_ab289cb6(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_5013a1f0 === 'function') {
    await nuxt_plugin_mixins_5013a1f0(app.context, inject)
  }

  if (typeof nuxt_plugin_entry_6e62af46 === 'function') {
    await nuxt_plugin_entry_6e62af46(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
